<template>
  <div class="mt-5">
    <!-- <div class="check-back text-muted text-center">
      <h1>Check Back Soon</h1>
      <small>New Events to Come...</small>
    </div> -->
    <Header/>
    <RoadShow/>
    <TradeShows/>
    <ShowContent/>
    <Testimonials/>
    <Footer/>
  </div>
</template>

<script>
  import Header from './components/Header.vue'
  import RoadShow from './components/RoadShow.vue'
  import TradeShows from './components/TradeShows.vue'
  import ShowContent from './components/ShowContent.vue'
  import Testimonials from './components/Testimonials.vue'
  import Footer from '../app/Footer.vue'

  export default {
    components:{
      Header,
      RoadShow,
      TradeShows,
      ShowContent,
      Testimonials,
      Footer
    }
  }
</script>

<style scoped>
  .check-back{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%);
  }
</style>